import React, { Component, useState } from "react";

export const Lealtad = ({confirm}) => {
    const [cardNumber, setCardNumber] = useState("");
    const [length, setLength] = useState(16);

    const placheHoler = () => {
      switch (length) {
        case 9:
          return "xxx xxx xxx";
        case 12:
          return "xxxx xxxx xxxx";
        case 16:
          return "xxxx xxxx xxxx xxxx";
        default:
          return "xxxx xxxx xxxx xxxx";
      }
    }

  return (
    <div className="card-body">
      <div className="row">
        <label>
        ¿De cuantos números es tú tarjeta?
        </label>
      <div className="form-group col-4">
        <select
          className="form-control"
          value={length}
          onChange={(e) => {
            setLength(Number(e.target.value))
          } }
        >
          <option value="9">9</option>
          <option value="12">12</option>
          <option value="16">16</option>
        </select>
      </div>
          <input
            className="form-control col-8"
            type="tel"
            onChange={(e) => setCardNumber(e.target.value)}
            inputMode="numeric"
            pattern="[0-9\s]{13,19}"
            maxLength={length}
            placeholder={placheHoler()}       
          ></input>

      </div>
      <div className="row justify-content-end pt-1 mr-0">
        <button className="btn btn-primary" style={{backgroundColor: "#203e60"}} disabled={cardNumber.length < length} onClick={() => confirm(cardNumber)}>Confirmar</button>
      </div>
    </div>
  );
};
